import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Breadcrumb} from 'antd';
import navigationConfig from "configs/NavigationConfig";
import IntlMessage from 'components/util-components/IntlMessage';
import Flex from "../shared-components/Flex";
import HelperService from "../../services/HelperService";

let breadcrumbData = {
  '/app': <IntlMessage id="home"/>
};

navigationConfig.forEach((elm, i) => {
  const assignBreadcrumb = (obj) => breadcrumbData[obj.path] = <IntlMessage id={obj.title}/>;
  assignBreadcrumb(elm);
  if (elm.submenu) {
    elm.submenu.forEach(elm => {
      assignBreadcrumb(elm)
      if (elm.submenu) {
        elm.submenu.forEach(elm => {
          assignBreadcrumb(elm)
        })
      }
    })
  }
})

const BreadcrumbRoute = withRouter(props => {
  const {location} = props;
  const pathSnippets = location.pathname.split('/').filter(i => i);
  const buildBreadcrumb = pathSnippets.map((string, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
    const breadcrumDataCheck = breadcrumbData[url] ?? string
    return (
      <Breadcrumb.Item key={url}>
        {
          index ? <Link to={url}>{HelperService.toTitleCase(string.replace('-', ' '))}</Link> : HelperService.toTitleCase(breadcrumDataCheck)
        }
      </Breadcrumb.Item>
    );
  });

  return (
    <Breadcrumb>
      {buildBreadcrumb}
    </Breadcrumb>
  );
});

export class AppBreadcrumb extends Component {
  render() {
    return (
      <Flex className={`breadcrumb-container ${this.props.className ? this.props.className : 'mb-4'}`} alignItems="center" justifyContent="between" mobileFlex={false}>
        <BreadcrumbRoute/>
      </Flex>
    )
  }
}

export default AppBreadcrumb
